var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#43b02a;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15,
    cy: 15,
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.5,12.062S4.531,6,9.835,6s8.335,6.062,8.335,6.062-3.031,6.062-8.335,6.062S1.5,12.062,1.5,12.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.046,15.773A2.273,2.273,0,1,1,15.773,13.5,2.273,2.273,0,0,1,18.046,15.773Z",
    transform: "translate(-5.938 -3.711)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c3002bfca8f0085f77f839083e5a63d4.svg";
export { ForwardRef as ReactComponent };